<template>
	<!-- 联系我们 -->
	<div class="callUS">
		<div class="leaveUnused">
			<div class="textCenter f28 pt25">云当铺</div>
			<div class="textGary f14">值得信赖的“闲置换钱”服务平台</div>
			<div class="line"></div>
		</div>
		<div class="product">
			<div class="list">
				<div class="right">
					<img src="../../static/shop/ydpContact.png" />
				</div>
				<div class="left">
					<div class="title f16">
						<div class="block"></div>“回收+寄存”助力卖家资金回笼
					</div>
					<div class="leftCon f12">云当铺拥有业内权威的鉴定回收团队，根据市场行情为卖家提供公平公正的回收报价。</div>
					<div class="leftCon f12">同时提供专业的寄存帮卖服务，竭力协助、促成交易，帮助卖家更快捷、更高效的回笼资金;</div>
				</div>

			</div>
			<!-- <div class="list" style="padding: 40px 0;">
                <div class="right">
                    <img src="../../static/slider/contactTwo.png" />
                </div>
                <div class="left">
                    <div class="title"><div class="block"></div>“品控+优选”买家放心挑购好物</div>
                    <div>秉承着“品质至上、诚信待人、专业服务”的宗旨，云当铺公开透明售价体系，向买家展现丰富多样的二手精品，每一件物品都经过智能质检系统和专业检测师的双重评估，品质真实、质量保障，无忧售后政策，让买家选购更省心、更放心;</div>
                </div>               
            </div> -->
		</div>
		<div class="map">
			<div class="right">
				<img :src="companyInfoIndex.mapUrl || '../../static/shop/contactMap.png'" />
			</div>
			<div class="left">
				<div class="title f16">
					<div class="block"></div>{{companyInfoIndex.name}}
				</div>
				<div class="leftCon f12">电话：{{companyInfoIndex.phone}}</div>
				<div class="leftCon f12">邮箱：{{companyInfoIndex.mailbox}}</div>
				<div class="leftCon f12">地址：{{companyInfoIndex.address}}</div>
			</div>

		</div>
	</div>

</template>
<script>
	export default {
		data() {
			return {
				companyInfoIndex: {}
			};
		},
		async mounted() {
			await this.getIndexContent();
		},
		// 列表循环滚动结束
		methods: {
			async getIndexContent() {
				let type = this.$route.query.id
				let res = await this.util.request({
					url: `/sy/website/getIndexContent/${type}`,
					method: 'GET',
					data: {},
				});
				if (res.status === 200) {
					this.companyInfoIndex = res.data.companyInfoIndex;
				} else {
					console.log(res.statusText);
				}
			},


		},
	}
</script>

<style lang="less" scoped>
	//2024-02-28 start
	.line {
		width: 35px;
		height: 2.5px;
		background: #FF354A;
		margin: auto;
		margin-top: 10px;
	}

	// 2024-02-28 end
	.callUS {
		width: 100%;
		margin: auto;

		.leaveUnused {
			.textGary {
				text-align: center;
				color: #999;
				margin-top: 0.5rem;
			}

		}
	}

	.product {
		width: 100%;
		display: flex;
		justify-content: center;

		.leftCon {
			padding-top: 10px;
			text-indent: 48px;
		}

		.list {
			width: 50%;
			display: flex;
			justify-content: center;
			letter-spacing: 4px;
			margin: 30px 40px;
			text-align: justify;
			align-items: center;

			.left {
				width: 50%;

				.title {
					display: flex;
					align-items: center;
					text-indent: 8px;
					font-weight: bold;

					.block {
						width: 26px;
						height: 26px;
						background: #000;
						margin-right: 10px;
						box-shadow: 5px 5px 0 #f00;
					}
				}

				span {
					width: 10px;
					height: 10px;
					background-color: #ff9999;
				}
			}

			.right {
				width: 50%;
				text-align: center;

				img {
					width: 80%;
					margin: auto;
				}
			}
		}

	}

	.map {
		.leftCon {
			padding-top: 10px;
			text-indent: 48px;
		}

		width: 65%;
		margin: auto;
		display: flex;
		justify-content: center;
		margin-bottom:4rem;

		.left {
			margin-top: 4%;

			.title {
				display: flex;
				align-items: center;
				text-indent: 8px;
				font-weight: bold;
			}

			.block {
				width: 26px;
				height: 26px;
				background: #000;
				margin-right: 10px;
				box-shadow: 5px 5px 0 #f00;
			}
		}

		.right {
			width: 50%;
			text-align: center;

			img {
				width: 80%;
				margin: auto;
			}
		}
	}
</style>

<style lang="less">
	.indexButtom {
		background-color: #fff !important;
		padding: 0 !important;
		margin-bottom: 0 !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/contactUs.vue